import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-7 gap-3 pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NextButton, {
      class: "col-start-2",
      component: "router-link",
      to: {name:'ListaUtenti'}
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Utenti")
      ])),
      _: 1
    }),
    _createVNode(_component_NextButton, {
      component: "router-link",
      to: {name:'ListaRuoli'}
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode("Gruppi")
      ])),
      _: 1
    }),
    _createVNode(_component_NextButton, {
      component: "router-link",
      to: {name:'ListaPermessi'}
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode("Permessi")
      ])),
      _: 1
    }),
    _createVNode(_component_NextButton, {
      component: "router-link",
      to: {name:'ListaAziendeGruppo'}
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [
        _createTextVNode("Aziende")
      ])),
      _: 1
    }),
    _createVNode(_component_NextButton, {
      component: "router-link",
      to: {name:'BusinessUnits'}
    }, {
      default: _withCtx(() => _cache[4] || (_cache[4] = [
        _createTextVNode("Business Unit")
      ])),
      _: 1
    }),
    _createVNode(_component_NextButton, {
      component: "router-link",
      class: "col-start-2",
      to: {name:'VociSpesaBusinessUnitsIva'}
    }, {
      default: _withCtx(() => _cache[5] || (_cache[5] = [
        _createTextVNode("IVA predefinita")
      ])),
      _: 1
    }),
    _createVNode(_component_NextButton, {
      component: "router-link",
      class: "",
      to: {name:'LoginNinja'}
    }, {
      default: _withCtx(() => _cache[6] || (_cache[6] = [
        _createTextVNode("Login ninja")
      ])),
      _: 1
    }),
    _createVNode(_component_NextButton, {
      component: "router-link",
      class: "",
      to: {name:'AttivitaTimesheet'}
    }, {
      default: _withCtx(() => _cache[7] || (_cache[7] = [
        _createTextVNode("Attività timesheet")
      ])),
      _: 1
    }),
    _createVNode(_component_NextButton, {
      component: "router-link",
      class: "",
      to: {name:'BilanciPrevisionali'}
    }, {
      default: _withCtx(() => _cache[8] || (_cache[8] = [
        _createTextVNode("Previsionale commerciale")
      ])),
      _: 1
    })
  ]))
}